<template>
    <div class="courses-single-page bg-dark-blue">
        <div class="container-fluid">
            <div class="row">
                <div class="col-lg-12">
                    <div class="content-page-wrap clearfix">
                        <div class="course-single">
                            <div class="card mt-3">
                                <div class="container-fluid">

                                    <div class="content">
                                        <div class="d-flex justify-content-between align-items-center">
                                            <div class="d-flex align-items-center">
                                                <div class="title text-dark-blue mr-4">
                                                    Course Packages
                                                </div>
                                                <div class="site-select mb-2" v-show="userRole == 'admin' && sites">
                                                    <select class="form-control" v-model="selectedSite">
                                                        <option v-for="site in sites" :value="site">{{site.name}}</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div class="tab-button" v-on:click="$router.push('/admin/coursePackages/0')">
                                                New Course Package
                                            </div>
                                        </div>
                                        <table class="table" style="overflow-y:scroll; max-height: 600px;">
                                            <thead>
                                                <tr>
                                                    <td>Name</td>
                                                    <td>Price</td>
                                                    <td>Enabled</td>
                                                    <td></td>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="pack in filteredPackages">
                                                    <td>{{ pack.name }}</td>
                                                    <td>
                                                        <span v-if="pack.priceUsd">R {{ pack.price }} / $ {{ pack.priceUsd }}</span>
                                                        <span v-else>R {{ pack.price }}</span>

                                                    </td>
                                                    <td>{{ pack.enabled }}</td>
                                                    <td>
                                                        <router-link :to="{ name: 'AdminCoursePackagesDetails', params: { id: pack.id }}">
                                                            <div class="btn-add-alt-2 text-center p-2">
                                                                Edit
                                                            </div>
                                                        </router-link>
                                                    </td>
                                                </tr>
                                                <tr v-show="filteredPackages.length < 1">
                                                    <td colspan="4">No course packages for selected site</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div><!-- courses-single -->
</template>

<style scoped>
    .tab-button {
        border-radius: 8px 8px 0 0;
        border: 1px solid #B8BEBF;
        background-color: #42C1C4;
        color: white;
        text-align: center;
        text-transform: uppercase;
        font-weight: 600;
        width: 200px;
        padding: 10px;
    }

        .tab-button:hover {
            background-color: white;
            color: #282D69;
            cursor: pointer;
            border: 1px solid #282D69;
        }
</style>

<script>
    export default {
        name: 'AdminCoursePackages',
        data: function () {
            return {
                coursePackages: [],
                sites: null,
                selectedSite: null,
            }
        },
        props: {

        },
        computed: {
            filteredPackages() {
                var filtered = [];
                if (this.selectedSite) {

                    var siteId = this.userRole == "admin" ? this.selectedSite.id : this.userSiteId;

                    for (var i = 0; i < this.coursePackages.length; i++) {
                        var currentPackage = this.coursePackages[i];
                        if (currentPackage.siteId == siteId) {
                            filtered.push(currentPackage);
                        }
                    }
                }
                return filtered;
            },
            userRole() {
                var roles = this.$store.state.user.roles;
                return roles[0];
            },
            userSiteId() {
                var id = this.$store.state.user.siteId;
                return id;
            }
        },
        async mounted() {
            //load courses
            var title = document.title;
            this.coursePackages = await this.web(`/coursePackages?siteTitle=${title}`, "Loading course packages");
            if (this.userRole == "admin") {
                this.sites = await this.web("/sites", "Loading sites");
                this.selectedSite = this.sites[0];
            }

            var crumbs = {};
            crumbs["/admin/coursePackages"] = "Course Packages";
            this.$store.commit("breadCrumbs", crumbs);
        }
    }
</script>
